import styled from 'styled-components';

import { media, getThemeColor, getGridBase } from '@utils/styled';

import Button from '@common/components/Button';
import AlertBox from '@common/components/AlertBox';
import Typography from '@common/components/Typography';
import { TextInput, InputsWrapper } from '@common/components/forms';

export const StepTitle = styled(Typography).attrs({ variant: 'h2' })``;

export const ProvidersAdditional = styled(Typography).attrs({
  variant: 'paragraph1',
})`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 3)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 3)};
`;

export const ButtonText = styled(Typography).attrs({
  variant: 'subtitle2',
  customAs: 'span',
})`
  margin: 0;
`;

export const NextButton = styled(Button)`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'section', 3)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'section', 3)};
`;

export const TextInputBirthDay = styled(TextInput)`
  flex: 0 0 6.6rem;
`;

export const TextInputBirthYear = styled(TextInput)`
  flex: 0 0 9.7rem;
`;

export const AlertWrapper = styled.div`
  ${getGridBase(12)};
  ${({ theme, spacingTop }) =>
    spacingTop && theme.getFluidSpacing('margin-top', ...spacingTop)};
  ${({ theme, spacingBottom }) =>
    spacingBottom && theme.getFluidSpacing('margin-bottom', ...spacingBottom)};
`;

export const MessageBox = styled(AlertBox)`
  grid-column: span 12;
  max-width: 100%;

  button {
    width: 100%;
    height: auto;
    padding-top: 1rem;
    padding-bottom: 1rem;
    white-space: normal;

    ${media.from640up`
      width: min-content;
      padding-top: 0;
      padding-bottom: 0;
      height: 4rem;
      white-space: nowrap;
    `}
  }
`;

export const GridWrapper = styled.ul`
  display: flex;
  gap: 1.5rem;
  flex-flow: row wrap;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const GridWrapperItem = styled(Typography).attrs({
  variant: 'body2',
  customAs: 'li',
})`
  margin-bottom: 0;
  color: ${getThemeColor('bluegrey.70')};
  text-align: left;
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'equal', 3)};
`;

export const ImageIconWrapper = styled.div`
  position: absolute;
  ${({ theme }) => theme.getFluidSpacing('top', 'scale', 9)};
  ${({ theme }) => theme.getFluidSpacing('bottom', 'scale', 9)};
  ${({ theme }) => theme.getFluidSpacing('left', 'scale', 9)};
  ${({ theme }) => theme.getFluidSpacing('right', 'scale', 9)};
`;

export const RadiosWrapper = styled(InputsWrapper)`
  grid-row-gap: 2.5rem;
`;
